var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 1.25H20V18.75H0V1.25H3.75V0H5V1.25H15V0H16.25V1.25ZM3.75 2.5H1.25V5H18.75V2.5H16.25V3.75H15V2.5H5V3.75H3.75V2.5ZM1.25 17.5H18.75V6.25H1.25V17.5ZM7.5 16.25V7.5H8.75V16.25H7.5ZM3.75 16.25V7.5H5V16.25H3.75ZM15 16.25V7.5H16.25V16.25H15ZM11.25 16.25V7.5H12.5V16.25H11.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.6ac123b88ad09dd52b96a86d0f49a6be.svg";
export { ForwardRef as ReactComponent };